<template>
    <led
        style="margin-left:-0.5rem"
        :classObj='lastSeen.style'
        :label="lastSeen.message"
    ></led>
</template>
<script>  
    export default {
        name: "CurrentOffsetDate",
        props: {
            'timestamp': Number
        },
        data(){
          return {
            now: null,
            intervalId: null
          }
        },

        created(){
          this.now = Date.now();
          this.intervalId = setInterval(()=>this.now = Date.now(),1000);
        },

        destroyed(){
            clearInterval(this.intervalId);
        },
        computed: {
            lastSeen(){

                if(!this.timestamp)
                  return {
                    message:"Never seen", 
                    style:  {
                        "red":true,
                        "darken-2":true,
                        "elevation-1":true
                    }
                  };
                
                let lastSeen = Math.floor((this.now+1000-this.timestamp)/1000);
                if(lastSeen<60){
                  return {
                    message: lastSeen + " second(s) ago", 
                    style:  {
                        "green":true,
                        "darken-2":true,
                        "elevation-1":true
                    }
                  };
                }
                
                if(lastSeen<60*60){
                  return {
                    message:Math.floor(lastSeen/60) + " minute(s) ago",
                    style:  {
                        "yellow":true,
                        "darken-1":true,
                        "elevation-1":true
                    }
                  };
                }

                if(lastSeen<60*60*24){
                  return {
                    message:Math.floor(lastSeen/(60*60)) + " hour(s) ago",
                    style:  {
                        "yellow":true,
                        "darken-3":true,
                        "elevation-1":true
                    }
                  };
                }
                
                if(lastSeen<60*60*24*30){
                  return {
                    message:Math.floor(lastSeen/(60*60*24)) + " day(s) ago",
                    style:  {
                        "amber":true,
                        "darken-2":true,
                        "elevation-1":true
                    }
                  };
                }

                if(lastSeen<60*60*24*30*12){
                  return {
                    message:Math.floor(lastSeen/(60*60*24*30)) + " month(s) ago",
                    style:  {
                        "orange":true,
                        "darken-2":true,
                        "elevation-1":true
                    }
                  };
                }

                return {
                  message:Math.floor(lastSeen/(60*24*30*12)) + " year(s) ago",
                  style:  {
                      "red":true,
                      "darken-2":true,
                      "elevation-1":true
                  }
                };
            }
        }
    }
</script>